import * as React from 'react';

import {Card} from "@mui/material";
import {styled} from "@mui/material/styles";

const StyledCard = styled(Card)(({ theme }) => ({
    border: '1px solid #eeecec',
    '& .MuiCardHeader-root': {
        position: 'relative',
        '& .MuiLinearProgress-root': {
            position: 'absolute',
            bottom: 0,
            left: 0,
        },
        '& .MuiCardHeader-title': {
            [theme.breakpoints.down('sm')]: {
                display: 'none',
            },
            [theme.breakpoints.up('sm')]: {
                display: 'block',
            },
            fontSize: '1.2rem',
            fontWeight: 400,
        },
        '& .MuiCardHeader-avatar': {
            marginRight: 0,
        },
    },
    '& .MuiCardContent-root': {
        '& .MuiList-root': {
            padding: 0,
            marginBottom: theme.spacing(2),
            '& .MuiListItem-root': {
                borderBottom: `1px solid ${theme.palette.divider}`,
                padding: theme.spacing(1, 2),
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                '& .MuiListItemText-root': {
                    marginRight: theme.spacing(2),
                },
            },
        },
    },
    '& .MuiCardActions-root': {
        padding: theme.spacing(3),
        width: '100%',
        justifyContent: 'space-between',
    }
}));


export const SettingCard = ({children, props, styles}) => {

    return (
        <StyledCard {...props} {...styles}>
            {children}
        </StyledCard>
    )
}